<app-breadcrumb [pathList]="pathList"></app-breadcrumb>
<div [ngBusy]="{busy: busy, message: 'Loading...', backdrop: true, delay: 0, minDuration: 0}"></div>

<form [formGroup]="championForm" (ngSubmit)="saveItem()">
    <div class="row d-flex justify-content-between">
        <div class="input-group input-group-sm  mb-2 item d-flex justify-content-start">
        </div>
        <div class="input-group input-group-sm mb-2 item add-item">
            <div class="input-group-append">
                <button class="btn btn-app" type="submit" [disabled]="championForm.invalid">
                    <i class="fas fa-save"></i>
                    Salva
                </button>
            </div>
        </div>
    </div>

    <div class="pr-3 pl-3 mb-5">
        <div class="table-responsive">
            <table class="table table-hover table-sm table-edit" id="defaultCheck1">
                <thead class="thead-default">
                    <tr>
                        <th scope="col" class="col-3">Descrizione</th>
                        <th scope="col" class="col-9">Valore</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>ID</td>
                        <td>
                            <input class="form-control form-control-sm" 
                                type="number" 
                                formControlName="id">
                        </td>
                    </tr>
                    <tr>
                        <td>Description</td>
                        <td>
                            <input class="form-control form-control-sm" 
                                type="text" 
                                formControlName="description" 
                                placeholder="nome del campionato">
                        </td>
                    </tr>
                    <tr>
                        <td>Data di inizio</td>
                        <td>
                            <input type="date" 
                                class="form-control form-control-sm"
                                formControlName="data_inizio">
                        </td>
                    </tr>
                    <tr>
                        <td>Data di fine</td>
                        <td>
                            <input type="date" 
                                class="form-control form-control-sm"
                                formControlName="data_fine">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="d-flex justify-content-between">
            <div class="input-group input-group-sm  mt-2 item d-flex justify-content-start">
            </div>
            <div class="input-group input-group-sm mt-2 item add-item">
                <div class="input-group-append">
                    <button class="btn btn-app" type="submit" [disabled]="championForm.invalid">
                        <i class="fas fa-save"></i>
                        Salva
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>
<app-angular-confirm></app-angular-confirm>
<app-alertbox #alertbox1 [alerts]=""></app-alertbox>